module.exports = __webpack_public_path__ + "img/slide-3.90dff104.webp";